(function () {
  'use strict';

  function formatVerifiedReviewsText(text) {
    var clean = (text || '').replace(/\s+/g, ' ').trim();
    var match = clean.match(/^(\d+)\s+reviews?$/i);
    if (!match) return null;

    var count = parseInt(match[1], 10);
    if (!count && count !== 0) return null;

    return count === 1 ? '1 Verified Review' : count + ' Verified Reviews';
  }

  function updateTextNode(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
  }

  function cleanReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;

    // Remove/hide the old static review strip if it exists in cached/theme sections.
    scope.querySelectorAll('.s2g-product-reviews').forEach(function (el) {
      el.setAttribute('hidden', 'hidden');
      el.style.display = 'none';
    });

    // Judge.me preview badge: "1 review" -> "1 Verified Review".
    scope.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
      var replacement = formatVerifiedReviewsText(el.textContent);
      if (replacement) updateTextNode(el, replacement);
    });

    // Judge.me main widget title: "Reviews" -> "Verified Reviews".
    scope.querySelectorAll('.jdgm-rev-widg__title, .jdgm-widget-title, .jdgm-all-reviews__title, h2, h3').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Reviews' || text === 'Review') {
        updateTextNode(el, 'Verified Reviews');
      }
    });

    // Avoid old theme/app static wording appearing inside product-page snippets.
    scope.querySelectorAll('*').forEach(function (el) {
      if (!el.children.length) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^3,?426\s+verified\s+reviews$/i.test(text) || /^5\s+stars\s+•\s+3,?426\s+verified\s+reviews$/i.test(text)) {
          el.style.display = 'none';
          el.setAttribute('hidden', 'hidden');
        }
      }
    });
  }

  function run() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    cleanReviews(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);

  var observer;
  function startObserver() {
    if (!document.body || observer) return;
    observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (shouldRun) run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
